import { render, staticRenderFns } from "./WRegisterTab.vue?vue&type=template&id=74cada60"
import script from "./WRegisterTab.vue?vue&type=script&lang=js"
export * from "./WRegisterTab.vue?vue&type=script&lang=js"
import style0 from "./WRegisterTab.vue?vue&type=style&index=0&id=74cada60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports